var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoriesIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "CategoriesIcon",
    d: "M12,9h.01M11,12h1v4h1m6.875-9.73A2.225,2.225,0,0,1,21,8.218V15.5a2.225,2.225,0,0,1-1.158,1.948l-6.75,4.27a2.269,2.269,0,0,1-2.184,0l-6.75-4.27A2.225,2.225,0,0,1,3,15.5V8.217A2.223,2.223,0,0,1,4.158,6.27l6.75-3.98a2.33,2.33,0,0,1,2.25,0l6.75,3.98Z",
    transform: "translate(-2 -1)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesIconDark);
export default __webpack_public_path__ + "static/media/CategoriesIconDark.f4e86b7f02a974592b0259ef6890711a.svg";
export { ForwardRef as ReactComponent };